import {avisoAguarde, JsonStrToDate, NumeroValido, retirarAguarde, tratarErro} from "./utils";

var divMain;
var divResumo;
var divResumoOdds;
var divItens;
var divRodape;
var divPagina;
var config;

var pesq = 0;

$(document).ready(function () {
  $(".modalWindow2, .modalBack").hide();
  $("#btSair").click(function () {
    $(".modalWindow2, .modalBack").fadeOut();
  });
  $(".modalBack").click(function () {
    $(".modalWindow2, .modalBack").fadeOut('fast');
  });

  divMain = $("#divMain");
  divResumo = $("#divResumo");
  divResumoOdds = $("#divResumoOdds");
  divItens = $("#divItens");
  divRodape = $("#divRodape");
  divPagina = $("#divPagina");

  divPagina.hide();

  //$("#txtDe").datepicker({ dateFormat: "dd/mm/yy" });
  //$("#txtAte").datepicker({ dateFormat: "dd/mm/yy" });

  //SearchText();

  window.PegaConfig(function () {
    if ((window.config.Auth.NIVEL != 3) && (window.config.Auth.NIVEL != 5) && (window.config.Auth.NIVEL != 10)) {
      $("#lbNJogos").hide();
      $("#txtNJogos").hide();
    }

    ConsultarTipoOdds();

  });

  $("#ddOrdem").change(function () {
    Pesquisar();
  }).change();

  $("#ddSit").change(function () {
    Pesquisar();
  }).change();

  $("#ddUsuarios").change(function () {
    Pesquisar();
  }).change();

  if ($("#lbJogo").length) {
    var descTmp = getParameterByName('dsc');
    $("#lbJogo").html(descTmp);

    var d = new Date();
    document.getElementById("txtDe").valueAsDate = d;
    document.getElementById("txtAte").valueAsDate = d;

  }

  pesq = 1;

});

var superv_id = 0;

function PopularSuperv(data) {
  superv_id = 0;
  var options = '<option value="0">Escolha um supervisor</option>';

  if (window.config.Auth.NIVEL == 5) {
    options += '<option value="-1">Usuários sem supervisor</option>';

    options += '<option value="-2">Usuários independentes</option>';
  }

  $.each(data, function (key, val) {
    options += '<option value="' + val.usr_id + '">' + val.login + '</option>';
  });
  $("#ddSuperv").html(options);

  $("#ddSuperv").change(function () {

    var str = "";

    $("#ddSuperv option:selected").each(function () {
      str += $(this).val();
    });

    superv_id = str;

    pesq = 0;

    ConsultarUsuarios();

    pesq = 1;

    Pesquisar();
  }).change();

  if (document.getElementById("txtDe").value == "") {
    var d = new Date();
    //var d2 = new Date();
    //d2.setDate(d2.getDate() - 7);
    document.getElementById("txtDe").value = d.format("yyyy-MM-dd");
    document.getElementById("txtAte").value = d.format("yyyy-MM-dd");
  }
}

function ConsultarUsuarios() {
  if ($("#ddUsuarios").length) {
    $("#ddUsuarios").html("");

    if (superv_id != 0) {
      avisoAguarde();

      $.ajax({
        url: urlApi + "/api/Usuarios/UsuariosSupervisor/" + superv_id,
        type: "GET",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        processdata: true,
        success: function (data) {
          PopularUser(data);
          retirarAguarde();
        },
        error: function (xhr) {
          retirarAguarde();
          tratarErro("Caixa:", xhr);
          return null;
        }
      });
    }
  }
}


function PopularUser(data) {
  var options = '<option value="0">Escolha um usuário</option>';

  $.each(data, function (key, val) {
    options += '<option value="' + val.usr_id + '">' + val.login + '</option>';
  });
  $("#ddUsuarios").html(options);
  $("#ddUsuarios").html(options);

  if (document.getElementById("txtDe").value == "") {
    var d = new Date();
    document.getElementById("txtDe").value = d.format("yyyy-MM-dd");
    document.getElementById("txtAte").value = d.format("yyyy-MM-dd");
  }

}

var exibirDet;

var pagAtual = 0;

window.Pesquisar = function () {

  divMain.html("");
  divResumo.html("");
  divResumoOdds.html("");
  divPagina.hide();

  if (pesq == 1) {

    var dtDe = window.StrToDateTimeMS(document.getElementById("txtDe").value + " " + document.getElementById("txtHoraDe").value + ":00.000");
    var dtAte = window.StrToDateTimeMS(document.getElementById("txtAte").value + " " + document.getElementById("txtHoraAte").value + ":59.999");

    if ((dtDe != null) && (dtAte != null)) {
      var tipoExib = 3; //detalhado

      try {
        if ($("#rbResumoGeral").is(":checked"))
          tipoExib = 0;
        else if ($("#rbResumoInd").is(":checked"))
          tipoExib = 1;
        else if ($("#rbResumoIndSuperv").is(":checked"))
          tipoExib = 2;
      } catch (ex) {
      }

      var opcaoOrdem = $("#ddOrdem option:selected").val();

      avisoAguarde();

      $("#btPesq").prop("disabled", "disabled");

      var situacao = $("#ddSit option:selected").val();

      var pagina = 1;
      try {
        pagina = parseInt($("#ddPagina option:selected").val());
      } catch (ex) {
      }
      if ((pagina == undefined) || isNaN(pagina)) pagina = 1;

      pagAtual = pagina - 1;//guarda o index da pagina

      var nJogos = 0;
      try {
        nJogos = parseInt(document.getElementById('txtNJogos').value);
      } catch (ex) {
      }
      if ((nJogos == undefined) || isNaN(nJogos)) nJogos = 0;

      exibirDet = $("#chkExibirDet").is(":checked") ? 1 : 0

      var userId = 0;
      if ($("#ddUsuarios").length) {
        try {
          userId = parseInt($("#ddUsuarios option:selected").val());
        } catch (ex) {
        }
        if ((userId == undefined) || isNaN(userId)) userId = 0;
      }

      var campJogId = 0;
      var oddtipo = 0;
      var remusoporodds = 0;

      if ($("#lbJogo").length) {
        campJogId = getParameterByName('id');
      }

      if ($("#ddTipoOdd").length) {
        oddtipo = $("#ddTipoOdd option:selected").val();
        remusoporodds = 1;
      }

      var cliente = "";
      if ($("#txtCliente").length) {
        cliente = $("#txtCliente").val().trim();
      }

      let opcoes = {
        superv_id: superv_id,
        Usr_id: userId,
        dtIni: dtDe,
        dtFim: dtAte,
        agrupado: tipoExib,
        status: situacao,
        Camp_Jog_Id: campJogId,
        oddTipo: oddtipo,
        nJogos: nJogos,
        pagina: pagina,
        itensPorPagina: 30,
        ordem: opcaoOrdem,
        detalhes: exibirDet,
        remusoPorOdds: remusoporodds,
        cliente: cliente,
      }

      var dadosStr = JSON.stringify(opcoes);

      $.ajax({
        url: url + "enet/getCaixa",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        processdata: true,
        data: dadosStr,
        success: function (data) {
          MontarGradeResumo(data.resumo, dtDe, dtAte);
          MontarGradeDados(data.dados, data.totalPaginas);
          MontarGradeResumoOdds(data.resumoOdds);
          retirarAguarde();
          $("#btPesq").prop("disabled", "");
        },
        error: function (xhr) {
          retirarAguarde();
          $("#btPesq").prop("disabled", "");
          tratarErro("Caixa:", xhr);
          return null;
        }
      });
    }
  }
}

function MontarGradeDados(dados, totalPaginas) {
  if (dados != undefined) {
    var resultado = "<table id='caixa' border='0' cellpadding='4' cellspacing='2' width='100%'><thead>{cabecalho}</thead><tbody>{itens}</tbody></table><br />";
    var linha = "<tr{css}><td>{codigo}</td><td>{clinome}</td><td align='center'>{njogos}</td><td align='right'>{vlaposta}</td><td align='right'>{vlcomissao}</td><td align='right'>{vlpremio}</td><td align='center'>{status}</td><td align='center'>{data}</td></tr>";

    var linhah = "<tr{css}><th>{codigo}</th><th>{clinome}</th><th align='center'>{njogos}</th><th align='right'>{vlaposta}</th><th align='right'>{vlcomissao}</th><th align='right'>{vlpremio}</th><th align='center'>{status}</th><th align='center'>{data}</th></tr>";
    var txt = linhah.replace("{css}", " class='tabelaCabRod'");
    txt = txt.replace("{codigo}", "Código");

    if (exibirDet == 1)
      txt = txt.replace("{clinome}", "Detalhes");
    else
      txt = txt.replace("{clinome}", "Cliente");

    txt = txt.replace("{njogos}", "Nº de Jogos");
    txt = txt.replace("{vlaposta}", "Vl. Aposta");
    txt = txt.replace("{vlcomissao}", "Vl. Comissão");
    txt = txt.replace("{vlpremio}", "Vl. Prêmio");
    txt = txt.replace("{status}", "Status");
    txt = txt.replace("{vlpago}", "Vl. Pago");
    txt = txt.replace("{data}", "Data");
    txt = txt.replace("{usuario}", "Usuário");

    resultado = resultado.replace("{cabecalho}", txt);

    var registros = "";

    for (let i = 0; i < dados.length; i++) {
      if (i % 2 == 0)
        txt = linha.replace("{css}", " class='tabelaLinhaImpar'");
      else
        txt = linha.replace("{css}", " class='tabelaLinhaPar'");

      var d = JsonStrToDate(dados[i].dt_cad);

      var btCodigo = "<button type='button' class='link2' onclick=\"javascript:window.PegaDetalhe('" + dados[i].apost_id + "');\">" + dados[i].apost_id + "</button>";

      var btCli = "";
      if (dados[i].cliente != "") btCli = "<button type='button' class='link2' onclick=\"javascript:window.PegaDetalhe('" + dados[i].apost_id + "');\">" + dados[i].cliente + "</button>";

      txt = txt.replace("{codigo}", btCodigo);

      if (exibirDet == 1) {
        var detalhes = "";
        for (let x = 0; x < dados[i].aposta_det.length; x++) {
          detalhes += dados[i].aposta_det[x].casa_nome + " x " + dados[i].aposta_det[x].visit_nome + "<br />Vencedor: <b>" + dados[i].aposta_det[x].odd_desc + "</b><br />";
        }

        txt = txt.replace("{clinome}", detalhes);
      } else
        txt = txt.replace("{clinome}", btCli);

      txt = txt.replace("{njogos}", dados[i].n_jogos);
      txt = txt.replace("{vlaposta}", dados[i].vl_aposta);
      txt = txt.replace("{vlcomissao}", (dados[i].vl_comissao.toLocaleString('pt-BR', {
        minimumFractionDigits: '2',
        maximumFractionDigits: '2'
      })));
      txt = txt.replace("{vlpremio}", (dados[i].vl_premio.toLocaleString('pt-BR', {
        minimumFractionDigits: '2',
        maximumFractionDigits: '2'
      })));
      txt = txt.replace("{status}", dados[i].status_desc);

      if (window.config.Auth.NIVEL > 0) {
        txt = txt.replace("{vlpago}", (dados[i].vl_pago > 0 ? dados[i].vl_pago.toLocaleString('pt-BR', {
          minimumFractionDigits: '2',
          maximumFractionDigits: '2'
        }) : ""));
      } else {
        if (dados[i].us_pag === dados[i].us_cad) {
          txt = txt.replace("{vlpago}", (dados[i].vl_pago > 0 ? dados[i].vl_pago.toLocaleString('pt-BR', {
            minimumFractionDigits: '2',
            maximumFractionDigits: '2'
          }) : ""));
        } else {
          txt = txt.replace("{vlpago}", "");
        }
      }

      //txt = txt.replace("{data}", d.format("dd/MM/yyyy - HH:mm"));
      txt = txt.replace("{data}", dados[i].dt_cad);
      txt = txt.replace("{usuario}", dados[i].login);

      registros += txt;
    }

    resultado = resultado.replace("{itens}", registros);

    divMain.append(resultado + "<br /><br />");

    var options = '';

    for (let i = 0; i < totalPaginas; i++) {
      if (pagAtual == i)
        options += '<option value="' + (i + 1) + '" selected="selected">' + (i + 1) + '</option>';
      else
        options += '<option value="' + (i + 1) + '">' + (i + 1) + '</option>';
    }
    $("#ddPagina").html(options);

    $("#lblTotalPag").text(totalPaginas);
    divPagina.show();
    $('#caixa').DataTable({paging: false, bSort: false})
  }
}


function MontarGradeResumoOdds(dados) {
  if (dados != undefined) {
    var resultado = "<table border='0' cellpadding='5' cellspacing='4' width='100%'{itens}</table><br />";
    var coluna = "<td><b>{desc}</b><br />Qtd.: {qtd}<br />Valor: <i>{valor}</i></td>";
    var linha = "";

    var registros = "";

    for (let i = 0; i < dados.length; i++) {
      if ((linha != "") && (i % 4 == 0)) {
        registros += '<tr>' + linha + '</tr>';
        linha = "";
      }

      linha += coluna;

      linha = linha.replace("{desc}", dados[i].Descricao);
      linha = linha.replace("{qtd}", dados[i].Qtd_Apostas);
      linha = linha.replace("{valor}", (dados[i].Vl_Aposta > 0 ? dados[i].Vl_Aposta.toLocaleString('pt-BR', {
        minimumFractionDigits: '2',
        maximumFractionDigits: '2'
      }) : ""));
    }

    if (linha != "") {
      registros += '<tr>' + linha + '</tr>';
    }

    resultado = resultado.replace("{itens}", registros);

    divResumoOdds.append(resultado + "<br /><br />");
  }
}

function MontarGradeResumo(resumo, dtDe, dtAte) {

  dtDe.setTime(dtDe.getTime() + dtDe.getTimezoneOffset() * 60 * 1000);
  dtAte.setTime(dtAte.getTime() + dtAte.getTimezoneOffset() * 60 * 1000);

  var resultado = "";

  var tabela = "<table border='0' cellpadding='4' cellspacing='2' width='100%'>{cabecalho}{itens}{rodape}</table><br /><br style=\"page-break-after:always;\" />";

  var linha = "";

  linha = "<tr{css}><td align='center'>{napostas}</td><td align='right'>{bruto}</td><td align='right'>{comissoes}</td><td align='right'>{premios}</td><td align='right'>{liquido}</td><td align='right'>{apagar}</td></tr>";

  var registros = "";

  var nLinha = -1;

  if (resumo.Bruto > 0) {
    resultado += tabela;

    let txt = linha.replace("{css}", " class='tabelaCabRod3'");
    txt = txt.replace("{napostas}", "Nº de Apostas");
    txt = txt.replace("{bruto}", "Bruto");
    txt = txt.replace("{premios}", "Prêmios");
    txt = txt.replace("{comissoes}", "Comissão");
    txt = txt.replace("{liquido}", "Líquido");
    txt = txt.replace("{apagar}", "A Pagar");

    resultado = resultado.replace("{cabecalho}", txt);

    resultado = resultado.replace("{itens}", registros);

    txt = linha.replace("{css}", " class='tabelaLinhaImpar'");
    txt = txt.replace("{desc}", "");
    txt = txt.replace("{napostas}", resumo.NApostas);
    txt = txt.replace("{bruto}", resumo.Bruto.toLocaleString('pt-BR', {
      minimumFractionDigits: '2',
      maximumFractionDigits: '2'
    }));
    txt = txt.replace("{premios}", resumo.Premios.toLocaleString('pt-BR', {
      minimumFractionDigits: '2',
      maximumFractionDigits: '2'
    }));
    txt = txt.replace("{comissoes}", resumo.Comissoes.toLocaleString('pt-BR', {
      minimumFractionDigits: '2',
      maximumFractionDigits: '2'
    }));
    txt = txt.replace("{liquido}", resumo.Liquido.toLocaleString('pt-BR', {
      minimumFractionDigits: '2',
      maximumFractionDigits: '2'
    }));
    txt = txt.replace("{apagar}", resumo.APagar.toLocaleString('pt-BR', {
      minimumFractionDigits: '2',
      maximumFractionDigits: '2'
    }));
    resultado = resultado.replace("{rodape}", txt);
  }

  divResumo.append(resultado);
}


window.PegaDetalhe = function (apostId) {
  divItens.html("");
  divRodape.html("");

  avisoAguarde();


  $.ajax({
    url: url + "enet/getBilhete/" + apostId,
    type: "GET",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    processdata: true,
    success: function (data) {
      MontarDetalhes(data);
      retirarAguarde();
    },
    error: function (xhr) {
      retirarAguarde();
      tratarErro("Caixa:", xhr);
      return null;
    }
  });
}


// Criar Aposta: quadro com a cotacao combinada e cada selecao com o resultado dela.
function MontarLegsBetBuilder(item) {
  const icones = {
    "Ganhou": "<span style='color:#28a745;font-weight:bold;' title='Ganhou'>&#10004;</span>",
    "Perdeu": "<span style='color:#dc3545;font-weight:bold;' title='Perdeu'>&#10008;</span>",
    "Adiado": "<span style='color:#888;' title='Anulado'>&#8856;</span>",
  };

  let html = "<table class='fonte12' cellpadding='2' cellspacing='0' style='width:100%;margin:2px 0;border:1px solid #5D7B9D;border-radius:4px;border-collapse:separate;'>";
  html += "<tr><td style='border-bottom:1px solid #ccc;'><b>Criar Aposta</b></td>"
    + "<td align='right' style='border-bottom:1px solid #ccc;'><b>" + Number(item.taxa).toLocaleString('pt-BR', {
      minimumFractionDigits: '2',
      maximumFractionDigits: '2'
    }) + "</b></td></tr>";

  for (const leg of item.legs) {
    html += "<tr><td>" + (leg.grupo ? leg.grupo + ": " : "") + "<b>" + leg.odd_desc + "</b></td>"
      + "<td align='right'>" + (icones[leg.sit_desc] || "<span style='color:#888;' title='Aberto'>&#9711;</span>") + "</td></tr>";
  }

  return html + "</table>";
}

function MontarDetalhes(dados) {
  if (dados != undefined) {
    let resultado = "<table border='0' cellpadding='1' cellspacing='0' width='100%'>{0}</table><br />";
    let linha = "<tr{css}><td>{jogo}</td><td>{botao}</td><td align='center'>{sit}</td><td align='center' class='hit' title='{tip}'>{result}</td></tr>";

    let txt = linha.replace("{css}", " style='color:White;background-color:#5D7B9D;font-weight:bold;'");
    txt = txt.replace("{jogo}", "Jogos");
    txt = txt.replace("{botao}", "&nbsp;");
    txt = txt.replace("{sit}", "Situação");
    txt = txt.replace("{result}", "Resultado");

    let registros = txt;

    for (let i = 0; i < dados.itens.length; i++) {
      if (i % 2 === 0)
        txt = linha.replace("{css}", " class='tabelaLinhaImpar4'");
      else
        txt = linha.replace("{css}", "");

      let descricao = "";

      if (dados.itens[i].esporte)
        descricao += "<span class='fonte7'>" + dados.itens[i].esporte + "</span>";

      if (window.config.Auth.ID === 2) {
        descricao += "<span class='fonte7'> - " + dados.itens[i].camp_jog_id + (dados.itens[i].evento_id ? " - " + dados.itens[i].evento_id : "") + "</span>";
      }

      descricao += "<br />";

      if (dados.itens[i].camp_nome)
        descricao += "<span class='fonte7'>" + dados.itens[i].camp_nome + "</span><br />";

      descricao += "<span class='fonte12'>" + dados.itens[i].casa_nome;

      if (dados.itens[i].visit_nome)
        descricao += " x " + dados.itens[i].visit_nome;
      descricao += "</span>";

      descricao += "<br />";

      // Loto/bicho: odd_desc ja descreve o palpite; sem "Vencedor" nem taxa zerada
      if (dados.itens[i].sorteio) {
        descricao += "<span class='fonte12'>" + dados.itens[i].odd_desc;
        if (dados.itens[i].taxa > 0)
          descricao += " - Taxa: " + dados.itens[i].taxa.toLocaleString('pt-BR');
        descricao += "</span><br />";
      } else if (dados.itens[i].legs && dados.itens[i].legs.length) {
        descricao += MontarLegsBetBuilder(dados.itens[i]);
      } else {
        descricao += "<span class='fonte12'>" + "Vencedor: " + dados.itens[i].odd_desc + " - Taxa: " + dados.itens[i].taxa.toLocaleString('pt-BR', {
          minimumFractionDigits: '2',
          maximumFractionDigits: '2'
        }) + "</span><br />";
      }

      descricao += "<span class='fonte12'>" + "Data: " + dados.itens[i].dt_jogo + "</span><br />";

      var botao = "&nbsp;";

      if (window.config.Auth.NIVEL == 5) {
        if (dados.itens[i].sit != 3) {
          botao = "<button type='button' onclick=\"javascript: window.CancelarItem('" + dados.itens[i].apost_det_id + "');\" style='width: 120px;'>Cancelar jogo</button>";
        } else {
          botao = "<button type='button' onclick=\"javascript: window.DesCancelarItem('" + dados.itens[i].apost_det_id + "');\" style='width: 120px;'>DEScancelar jogo</button>";
        }
      }

      var placar = "";
      var toolTip = "";

      if (NumeroValido(dados.itens[i].casa_1) && NumeroValido(dados.itens[i].fora_1)) {
        placar += "1º Tempo: " + dados.itens[i].casa_1 + " x " + dados.itens[i].fora_1;
      }

      if (NumeroValido(dados.itens[i].casa_2) && NumeroValido(dados.itens[i].fora_2)) {
        placar += "<br />2º Tempo: " + dados.itens[i].casa_2 + " x " + dados.itens[i].fora_2;
      }

      if (NumeroValido(dados.itens[i].casa) && NumeroValido(dados.itens[i].fora)) {
        placar += "<br />90'': " + dados.itens[i].casa + " x " + dados.itens[i].fora;
      }

      //}

      txt = txt.replace("{jogo}", descricao);
      txt = txt.replace("{botao}", botao);
      txt = txt.replace("{sit}", dados.itens[i].sit_desc);
      txt = txt.replace("{result}", placar);
      txt = txt.replace("{tip}", toolTip);

      registros += txt;
    }

    resultado = resultado.replace("{0}", registros);

    divItens.append(resultado + "<br /><br />");


    ///////////////////

    resultado = "<table border='0' cellpadding='4' cellspacing='2' width='100%'>{0}</table><br />";
    linha = "<tr><td align='right'>{1}</td><td align='right'>{2}</td><td align='right'>{3}</td><td align='right'>{4}</td></tr>";

    registros = "";

    txt = linha;
    txt = txt.replace("{1}", "Código:");
    txt = txt.replace("{2}", dados.aposta.codigo);
    txt = txt.replace("{3}", "");
    txt = txt.replace("{4}", "");

    registros += txt;

    txt = linha;
    txt = txt.replace("{1}", "Cliente:");
    txt = txt.replace("{2}", dados.aposta.cliente);
    txt = txt.replace("{3}", "Usuário:");
    txt = txt.replace("{4}", dados.aposta.login);

    registros += txt;

    txt = linha;
    txt = txt.replace("{1}", "Valor da Aposta:");
    txt = txt.replace("{2}", dados.aposta.vl_aposta.toLocaleString('pt-BR', {
      minimumFractionDigits: '2',
      maximumFractionDigits: '2'
    }));
    txt = txt.replace("{3}", "N. de Jogos:");
    txt = txt.replace("{4}", dados.aposta.n_jogos);

    registros += txt;

    //var d = JsonStrToDate(dados.aposta.dt_cad);

    //d.setHours(d.getHours() + config.Fuso);

    txt = linha;
    txt = txt.replace("{1}", "Data:");
    txt = txt.replace("{2}", dados.aposta.dt_cad);
    txt = txt.replace("{3}", "Valor do Prêmio:");
    txt = txt.replace("{4}", dados.aposta.vl_premio.toLocaleString('pt-BR', {
      minimumFractionDigits: '2',
      maximumFractionDigits: '2'
    }));

    registros += txt;

    txt = linha;
    txt = txt.replace("{1}", "Qtd Acertos:");
    txt = txt.replace("{2}", (dados.aposta.qtd_acertos != null ? dados.aposta.qtd_acertos : ""));
    txt = txt.replace("{3}", "Status:");
    txt = txt.replace("{4}", dados.aposta.status_desc);

    registros += txt;

    var dtCanc = JsonStrToDate(dados.aposta.dt_canc);

    txt = linha;
    txt = txt.replace("{1}", "Cancelado por:");
    txt = txt.replace("{2}", (dados.aposta.us_canc_nome != null ? dados.aposta.us_canc_nome : "") + (dtCanc != null ? " - " + dtCanc.format("dd/MM/yyyy - HH:mm") : ""));
    txt = txt.replace("{3}", "Vl. Pago:");
    txt = txt.replace("{4}", (dados.aposta.vl_pago != null ? dados.aposta.vl_pago.toLocaleString('pt-BR', {
      minimumFractionDigits: '2',
      maximumFractionDigits: '2'
    }) : ""));

    registros += txt;

    if (dados.aposta.solic_cancel == 1) {
      var dtSolicCanc = JsonStrToDate(dados.aposta.solic_cancel_data);

      txt = linha;
      txt = txt.replace("{1}", "Solicitação de cancelamento:");
      txt = txt.replace("{2}", (dtSolicCanc != null ? dtSolicCanc.format("dd/MM/yyyy - HH:mm") : ""));
      txt = txt.replace("{3}", "&nbsp;");
      txt = txt.replace("{4}", "&nbsp;");

      registros += txt;

    }

    txt = "<tr><td align='right' colspan='4'>{2}{4}</td></tr>";

    var podeIr = false;

    var btReimp = "";
    if (window.config.Auth.NIVEL == 5) {
      if (dados.aposta.status != 2) podeIr = true;
    } else if (window.config.Auth.NIVEL == 1) {
      if (dados.aposta.status != 2)
        if (window.config.Permite_Reimp) podeIr = true;
    } else {
      if (dados.aposta.status != 2)
        if (window.config.Permite_Reimp_Camb) podeIr = true;
    }
    if (podeIr == true) btReimp = "<button type='button' onclick=\"javascript: window.Reimprimir('" + dados.aposta.codigo + "');\" style='width: 120px;' >Reimprimir</button>";

    var btSolicCancel = "";
    btSolicCancel = "<button type='button' onclick=\"javascript: window.SolicCancel('" + dados.aposta.codigo + "');\" style='width: 120px;' >Cancelar bilhete</button>";

    var btCashout = "";

    var cashout_ativo = window.config.cashout_ativo || "nao";
    if (cashout_ativo === "sim") {
      btCashout = "<button type='button' onclick=\"javascript: window.CashOut('" + dados.aposta.codigo + "');\" style='width: 120px;' >Cashout</button>";
    }

    txt = txt.replace("{2}", btReimp + btSolicCancel + btCashout);

    txt = txt.replace("{4}", "<input id='btImagem' type='button' value='Imagem' style='width: 120px;' /><input id='btSair' type='button' value='Sair' style='width: 120px;' />");

    registros += txt;

    resultado = resultado.replace("{0}", registros);

    divRodape.append(resultado);

    $(".modalWindow2, .modalBack").fadeIn();
    //dados.aposta.codigo
    $("#btSair").click(function () {
      $(".modalWindow2, .modalBack").fadeOut();
    });

    $("#btImagem").click(function () {
      window.open(url + 'home/bilhete_png/' + dados.aposta.codigo, '_blank');
    });
  }
}

window.Reimprimir = function (cod) {
  if (confirm('Tem certeza que deseja reimprimir este bilhete agora?')) {
    window.open(url + "enet/bilhetetxt/" + cod, "popup_window", "height = 650 , width = 850, resizable = no, scrollbars = yes, location = no");
  }
}

window.SolicCancel = function (apostId) {
  if (confirm('Tem certeza que deseja solicitar o cancelamento?')) {


    $.ajax({
      url: url + "enet/cancelar/" + apostId,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      processdata: true,
      statusCode: {
        200: function (xhr) {
          Pesquisar();
          $(".modalWindow2, .modalBack").fadeOut();
        }
      },
      error: function (xhr) {
        retirarAguarde();
        tratarErro("Caixa:", xhr);
        return null;
      }
    });
  }
}

function Cancelar(apostId) {
  if (confirm('Tem certeza que deseja CANCELAR este bilhete?')) {
    avisoAguarde();


    $.ajax({
      url: urlApi + "/api/Caixa/Cancelar/" + apostId,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      processdata: true,
      statusCode: {
        200: function (xhr) {
          Pesquisar();
          $(".modalWindow2, .modalBack").fadeOut();
        }
      },
      error: function (xhr) {
        retirarAguarde();
        tratarErro("Caixa:", xhr);
        return null;
      }
    });
  }
}

function Descancelar(apostId) {
  if (confirm('Tem certeza que deseja DESCANCELAR este bilhete?')) {
    avisoAguarde();


    $.ajax({
      url: urlApi + "/api/Caixa/Descancelar/" + apostId,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      processdata: true,
      statusCode: {
        200: function (xhr) {
          Pesquisar();
          $(".modalWindow2, .modalBack").fadeOut();
        }
      },
      error: function (xhr) {
        retirarAguarde();
        tratarErro("Caixa:", xhr);
        return null;
      }
    });
  }
}

function CancelarItem(apostDetId) {
  if (confirm('Tem certeza que deseja CANCELAR este jogo?')) {
    avisoAguarde();


    $.ajax({
      url: urlApi + "/api/Caixa/CancelarItem/" + apostDetId,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      processdata: true,
      statusCode: {
        200: function (xhr) {
          Pesquisar();
          $(".modalWindow2, .modalBack").fadeOut();
        }
      },
      error: function (xhr) {
        retirarAguarde();
        tratarErro("Caixa:", xhr);
        return null;
      }
    });
  }
}

function DesCancelarItem(apostDetId) {
  if (confirm('Tem certeza que deseja DEScancelar este jogo?')) {
    avisoAguarde();


    $.ajax({
      url: urlApi + "/api/Caixa/DesCancelarItem/" + apostDetId,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      processdata: true,
      statusCode: {
        200: function (xhr) {
          Pesquisar();
          $(".modalWindow2, .modalBack").fadeOut();
        }
      },
      error: function (xhr) {
        retirarAguarde();
        tratarErro("Caixa:", xhr);
        return null;
      }
    });
  }
}

function ConsultarTipoOdds() {
  if ($("#ddTipoOdd").length) {

    var filtro = "?$filter=ESPORTE_ID eq 1 and ATIVO ge 0";
    var ordem = "&$orderby=ESCOPO,CATEGORIA_ID,KEY_TAG,DPARAM,ODD_TIPO";

    avisoAguarde();

    $.ajax({
      url: urlApi + "/api/TipoOdds" + filtro + ordem,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      processdata: true,
      success: function (data) {
        PopularTipoOdds(data);
        retirarAguarde();
      },
      error: function (xhr) {
        retirarAguarde();
        tratarErro("Caixa:", xhr);
        return null;
      }
    });

  }
}

function PopularTipoOdds(data) {
  superv_id = 0;
  var options = '<option value="0">Todos</option>';

  $.each(data, function (key, val) {
    options += '<option value="' + val.ODD_TIPO + '">' + val.DESCRICAO + '</option>';
  });
  $("#ddTipoOdd").html(options);

}
